import { render, staticRenderFns } from "./HighChartReflow.vue?vue&type=template&id=0cfe1984&scoped=true"
import script from "./HighChartReflow.vue?vue&type=script&lang=ts"
export * from "./HighChartReflow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfe1984",
  null
  
)

export default component.exports